var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2899_16787",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2899_16787",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAACzklEQVR4nO2Yy2tTQRTGfyW2FaFV6wOtDxC7slsfIFERRdSlBLeK6MZW/wJR/Dt8VTe6VIuiCG4kPkCLtIJoFTS6UuuiUSOKjhz4Lgwh1rS9c3OR+eCQ5Mw5k3wz35k5uRAR0RK4DOw5sOx/IOKyIONkoecPTsZlROSZXseAJSG/KBSS+ZcCoyF3JisiaCdGQ5HJkoghGJmsiQQj0woiQci0ikjqZLK8R/5lY2l8UShMtwPILZHMfoeLRNKFizsiRGmlDBelJURppQwXpSVEaaUMF6UlRGmlDBellTNplYCRPBNZABwBhoEKUJNV5DusGENbHomsAi4C35v4e1sDhpSTGyLtwGngm+b9AVwFDgDrgC6ZvT8IXFOMxX4FTgFzWk1kNXBf8/0CzgJrgE7gGPAQ+CJ7AAwCHYo5pxzLLc9kd9Iisgn4qLnGgaL8K4CnU8hqBOhV7BbglfwfgA1ZE9mlVXYq4Pnyd3ok3ulk6pLtA15q7Il2BhX+DfmrwI6siGyVtm2OM0DBGzvukehpkNsDvFfMgOcvSGpOC1QMTaQP+Kz8Cw2Oz0cas50w7BUpsz3y7VeM1YyPNp1kNjYBrA1FZK4ecVruLZ1W9ahq3KSECDiZ3SNIhvZ5skG+zXm72cepaRC542ncx6TGu/NMJJHWhPKv1NUHOm6dChvJqSLbLV9JMXZs10vrksY+hZRWgqJX7JfrJDYo/wtg0V+KfVwxRz1/wasPK/bNWR2/O716uAsslr9D94TT6WSF3S0reSQeewuwUDWXyG17qMf+vt1UrRg26hIz/xvv/O/1yDQyI7FcsduA196FuH46qzkbIkmhz/NalLL8v6XxPu3MgOqgKitLTu3S/5ByLPfebBvINGAN30mvbn7qtj8E9HvS6pdvWDFJPZyYadMYCit1SdaabOPPqy/LLeyesJW/DrxVe29mdWQtvI0lvdmU+ANRqcsp/AAWdgAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/viewIcon.906072fd1858fe83ccf3886f392224c0.svg";
export { ForwardRef as ReactComponent };